export const ListQueryKey = 'rollConfigs';
export const DetailQueryKey = 'rollConfig';

export const Urls = {
  selectUrl: '/rollConfig/list',
  updateUrl: '/rollConfig/update',
  deleteUrl: '/rollConfig/delete',
  createUrl: '/rollConfig/create',
  detailUrl: '/rollConfig/detail',
};
